/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getFutureTeamMemberScheduleSummary} from '../api'

 export const useQueryGetFutureTeamMemberScheduleSummary = createReactQueryHook('getFutureTeamMemberScheduleSummary', getFutureTeamMemberScheduleSummary)
